import { Disclosure } from "@headlessui/react";
import { MapIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AddButton from "../../../../components/AddButton";
import CloseIconButton from "../../../../components/CloseIconButton";
import CustomLoader from "../../../../components/CustomLoader";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import { toast } from "../../../../components/toastNotification";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import AreaTable from "../../OfficeHierarchy/Area/AreaTable";
import DistrictTable from "../../OfficeHierarchy/District/DistrictTable";
import { useParentHierarchyByCode } from "../../OfficeHierarchy/hooks/useParentHierarchyByCode";
import OfficeHierarchyActivyTable from "../../OfficeHierarchy/views/OfficeHierarchyActivyTable";
import OfficeHierarchyOfficesTable from "../../OfficeHierarchy/views/OfficeHierarchyOfficesTable";
import RegionTable from "../../OfficeHierarchy/Region/RegionTable";
import {
  empHierarchyState,
  officeHierarchyOnShowState,
  officeHierarchyTitle,
  officeHierarchyRecordTypeModalState,
} from "../atoms/atoms";
import { employeeFromOfficeHierarchy } from "../../Employees/Confie/atoms/atoms";
import { mainSelectedTab, onCloseSetPage } from "../../atoms";
import { useHistory } from "react-router-dom";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { OFFICE_PERMISSIONS } from "modules/CarrierAgreementMgmt/OfficeSettings/permission";
const OfficeHierarchyView = ({
  setOfficeHierarchyId,
  isParent,
  onClickOfficeHierarchyName,
  handleEdit,
  isLinked,
  CancelLink,
  dataOfficeHierarchy,
}) => {
  const setShowState = useSetRecoilState(officeHierarchyOnShowState);
  const setShowRecordTypeModal = useSetRecoilState(
    officeHierarchyRecordTypeModalState
  );
  const viewContactPermission =
    PERMISSIONS.permission_employee_contactdetails_view;
  const viewAdditionalPermission =
    PERMISSIONS.permission_employee_additionaldetails_view;
  const viewTrainingPermission =
    OFFICE_PERMISSIONS.permission_office_generalinformation_view;
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_add;
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_edit;

  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [hierarchyTitle, setHierarchyTitle] =
    useRecoilState(officeHierarchyTitle);
  const { data, isFetching } = useParentHierarchyByCode(
    setOfficeHierarchyId,
    isParent
  );
  const setViewFromHierarchy = useSetRecoilState(employeeFromOfficeHierarchy);
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const setEditState = useSetRecoilState(empHierarchyState);
  const setOnCloseSetPage = useSetRecoilState<any>(onCloseSetPage);

  let page = localStorage.getItem("page");
  const onClickEmployee = (employeeId, data) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        officeHierarchyId: data.officeHierarchyId,
        idEmployee: employeeId,
        actionToManager: "ManagerRedirection",
        prevPage: page,
      },
    });

    window.location.reload();

    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };
  const onClickSalesPres = (data) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        salesPresId: data.salesPresId,
        actionToSalesPres: "SalesPresRedirection",
      },
    });

    window.location.reload();

    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };
  const onClickSalesVP = (data) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        salesVPId: data.salesVPId,
        actionToSalesVP: "SalesVPRedirection",
      },
    });
    window.location.reload();

    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (data === "Parent hierarchy data not found") {
      toast.fire("Office hierarchy", "Server Error: " + data, "error");
    } else {
      if (data && !isFetching) {
        setHierarchyTitle(data?.officeHierarchyName);
      } else if (isFetching) {
        setHierarchyTitle("");
      }
    }
  }, [isFetching, data]);
  const onClickParentHierarchy = (data) => {
    onClickOfficeHierarchyName(data, false);
  };
  return (
    <div className="py-2">
      {!isFetching ? (
        <>
          <div className="relative mx-8 my-4 px-2 text-xs py-2 box-shadow border-quinary border-l-2">
            <CloseIconButton
              onClick={() => {
                isLinked ? CancelLink() : setShowState(false);
                localStorage.removeItem("ohIdRedirect");
                localStorage.removeItem("ohIdFromOffice");
                setOnCloseSetPage(true);
              }}
            />
            <div className="flex mx-2 justify-between pb border-secondary border-b-2">
              <div className="flex gap-2 items-center pb-2">
                <div>
                  <MapIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Office Hierarchy
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    {" "}
                    {hierarchyTitle}
                  </h1>
                </div>
              </div>{" "}
              <div className="flex justify-between">
                <div className="flex items-center gap-2">
                  {userPermissions.includes(addPermission) && (
                    <AddButton
                      buttonText="Add"
                      onClick={() => {
                        setShowRecordTypeModal(true);
                      }}
                      className={undefined}
                      disabled={undefined}
                    />
                  )}
                  {userPermissions.includes(editPermission) && (
                    <EditOutlineButton
                      buttonText="Edit"
                      onClick={() => {
                        handleEdit(data);
                        setEditState(true);
                      }}
                      className={undefined}
                      disabled={undefined}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="bg-bgDB">
              {userPermissions.includes(viewContactPermission) && data ? (
                <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
                  <div className="text-quinary font-bold font-sans py-2 px-6">
                    Office Hierarchy Details
                  </div>
                  <div className=" ">
                    {localStorage.setItem(
                      "ohIdRedirect",
                      data?.officeHierarchyId
                    )}
                    {data?.type === "District" ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 text-xs  py-2">
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              District Name:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              <span className="pr-2">
                                {data?.officeHierarchyName}
                              </span>
                              {data?.fullname}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Type:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.type}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Description:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.description}
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              {" "}
                              District Code:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.hierarchyCode}
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Region Code:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.regionCode}
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Area Code:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.areaCode}
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Territory Code:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.territoryCode}
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Id:
                            </label>
                            <div className="col-span-2  expandedData fontExpand">
                              <label className="px-2.5 py-0.5 rounded-md  bg-purple-100 text-purple-800">
                                {" "}
                                {data?.idC}{" "}
                              </label>
                            </div>{" "}
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Status:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              <div className="col-span-2  expandedData fontExpand">
                                {data?.isActive ? "Active" : "Inactive"}
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Owner:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.createdBy}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Record Type:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.type}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Parent Hierarchy:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  let ParentOH = dataOfficeHierarchy?.filter(
                                    (x) =>
                                      x.idC ===
                                        Number(data?.parentHierarchyId) &&
                                      x.type === "Region (Market)"
                                  )[0];
                                  ParentOH
                                    ? onClickParentHierarchy(ParentOH)
                                    : toast.fire(
                                        "Office hierarchy",
                                        "Parent hierarchy not found.",
                                        "error"
                                      );
                                }}
                              >
                                <span className="blueAndBold underline text-xs">
                                  {data?.parentHierarchy}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Parent Hierarchy Id:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.parentHierarchyId}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-2 ">
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Name:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              <span className="pr-2">
                                {data?.officeHierarchyName}
                              </span>
                              {data?.fullname}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Description:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.description}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2 ">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Type:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.type}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2 ">
                            {" "}
                            <label className=" fontExpand expandedLabel mx-4  ">
                              {" "}
                              Code:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.hierarchyCode}
                            </div>
                          </div>
                          <div className="grid grid-cols-3 p-2 ">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Id:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              <label className="px-2.5 py-0.5 rounded-md  bg-purple-100 text-purple-800">
                                {data?.idC}
                              </label>
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Status:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.isActive ? "Active" : "Inactive"}
                            </div>
                          </div>
                        </div>
                        <div className="p-2 divide-y">
                          <div className="grid grid-cols-3 p-2">
                            <label className="   fontExpand expandedLabel mx-4  ">
                              Owner:
                            </label>
                            <div className="col-span-2 expandedData fontExpand">
                              {data?.createdBy}
                            </div>
                          </div>
                          {data?.type !== "Territory" ? (
                            <>
                              <div className="grid grid-cols-3 p-2">
                                <label className="   fontExpand expandedLabel mx-4  ">
                                  Parent Hierarchy:
                                </label>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    let ParentOH = dataOfficeHierarchy?.filter(
                                      (x) =>
                                        x.idC ===
                                          Number(data?.parentHierarchyId) &&
                                        x.type ===
                                          (data?.type === "Region (Market)"
                                            ? "Area"
                                            : "Territory")
                                    )[0];
                                    ParentOH
                                      ? onClickParentHierarchy(ParentOH)
                                      : toast.fire(
                                          "Office hierarchy",
                                          "Parent hierarchy not found.",
                                          "error"
                                        );
                                  }}
                                >
                                  <span className="blueAndBold underline text-xs">
                                    {data?.parentHierarchy}
                                  </span>
                                </div>
                              </div>
                              <div className="grid grid-cols-3 p-2">
                                <label className="   fontExpand expandedLabel mx-4  ">
                                  Parent Hierarchy Id:
                                </label>
                                <div className="col-span-2 expandedData fontExpand">
                                  {data?.parentHierarchyId}
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              {userPermissions.includes(viewAdditionalPermission) && data ? (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <div className="m-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Leadership
                          </span>
                        </Disclosure.Button>

                        <Disclosure.Panel className="">
                          {data?.type === "District" ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager:
                                  </label>
                                  <label className="text-xs text-gray-700 text-left">
                                    <span
                                      className="cursor-pointer"
                                      onClick={() => {
                                        onClickEmployee(data?.idEmployee, data);
                                      }}
                                    >
                                      {data?.managerName && (
                                        <Tooltip
                                          title={
                                            <div className="">
                                              <span>
                                                {"Phone Number: " +
                                                  (data?.managerPhoneNumber
                                                    ? data?.managerPhoneNumber
                                                    : "No Data")}
                                              </span>
                                              <br />
                                              <span>
                                                {"Mobile Number: " +
                                                  (data?.managerMobileNumber
                                                    ? data?.managerMobileNumber
                                                    : "No Data")}
                                              </span>
                                            </div>
                                          }
                                          placement="top"
                                        >
                                          <div className="blueAndBold underline text-xs">
                                            {data?.managerName}
                                          </div>
                                        </Tooltip>
                                      )}
                                    </span>
                                  </label>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Phone Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <label className=" text-primary ">
                                      {" "}
                                      {data?.managerPhoneNumber}{" "}
                                    </label>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <label className=" text-primary ">
                                      {" "}
                                      {data?.managerEmail}{" "}
                                    </label>
                                  </div>
                                </div>
                                {/* <div className="grid grid-cols-3 p-2">
                             <label className="   fontExpand expandedLabel mx-4  ">
                               Manager Phone Number:
                             </label>
                             <div className="col-span-2 expandedData fontExpand">
                               {rowData.managerPhoneNumber}
                             </div>
                             
                           </div> */}
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Employee Id:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <label className="px-2.5 py-0.5 rounded-md  bg-purple-100 text-purple-800">
                                      {" "}
                                      {data?.employeeNumber}
                                    </label>{" "}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Effective Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.managerEffectiveDate
                                      ? new Date(
                                          data?.managerEffectiveDate
                                        ).toLocaleDateString()
                                      : ""}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Previous Manager:
                                  </label>
                                  {data?.previousManager && (
                                    <Tooltip
                                      title={
                                        <div>
                                          <span>
                                            {"Phone Number: " +
                                              (data?.previousManagerPhoneNumber
                                                ? data?.previousManagerPhoneNumber
                                                : "No Data")}
                                          </span>
                                          <br></br>
                                          <span>
                                            {"Mobile Number: " +
                                              (data?.previousManagerMobileNumber
                                                ? data?.previousManagerMobileNumber
                                                : "No Data")}
                                          </span>
                                        </div>
                                      }
                                      placement="top"
                                    >
                                      {data?.previousManagerId ? (
                                        <div>
                                          <span
                                            className="cursor-pointer"
                                            onClick={() => {
                                              onClickEmployee(
                                                data?.previousManagerId,
                                                data
                                              );
                                            }}
                                          >
                                            <div className="blueAndBold underline text-xs">
                                              {data?.previousManager}
                                            </div>
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="col-span-2 expandedData fontExpand">
                                          {data?.previousManager}
                                        </div>
                                      )}
                                    </Tooltip>
                                  )}
                                </div>
                              </div>
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sales President:
                                  </label>
                                  <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                      onClickSalesPres(data);
                                    }}
                                  >
                                    <div className="blueAndBold underline text-xs">
                                      {data?.salesPresident}
                                    </div>
                                  </span>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sales President Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.salesPresidentEmail}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sales President Phone:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.salesPresidentPhoneNumber}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sale VP:
                                  </label>

                                  <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                      onClickSalesVP(data);
                                    }}
                                  >
                                    <div className="blueAndBold underline text-xs">
                                      {data?.salesVp}
                                    </div>
                                  </span>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sale VP Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.salesVPEmail}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Sales VP Phone:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.salesVPPhoneNumber}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 text-xs  py-2">
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager:
                                  </label>
                                  <label className="text-xs text-gray-700 text-left">
                                    <span
                                      className="cursor-pointer"
                                      onClick={() => {
                                        onClickEmployee(data?.idEmployee, data);
                                      }}
                                    >
                                      {data?.managerName && (
                                        <Tooltip
                                          title={
                                            <div>
                                              <span>
                                                {"Phone Number: " +
                                                  (data?.managerPhoneNumber
                                                    ? data?.managerPhoneNumber
                                                    : "No Data")}
                                              </span>
                                              <br></br>
                                              <span>
                                                {"Mobile Number: " +
                                                  (data?.managerMobileNumber
                                                    ? data?.managerMobileNumber
                                                    : "No Data")}
                                              </span>
                                            </div>
                                          }
                                          placement="top"
                                        >
                                          <div className="blueAndBold underline text-xs">
                                            {data?.managerName}
                                          </div>
                                        </Tooltip>
                                      )}
                                    </span>
                                  </label>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Phone Number:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    <label className=" text-primary ">
                                      {" "}
                                      {data?.managerPhoneNumber}{" "}
                                    </label>
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Email:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.managerEmail}
                                  </div>
                                </div>
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Manager Effective Date:
                                  </label>
                                  <div className="col-span-2 expandedData fontExpand">
                                    {data?.managerEffectiveDate
                                      ? new Date(
                                          data?.managerEffectiveDate
                                        ).toLocaleDateString()
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="p-2 divide-y">
                                <div className="grid grid-cols-3 p-2">
                                  <label className="   fontExpand expandedLabel mx-4  ">
                                    Previous Manager:
                                  </label>
                                  {data?.previousManager && (
                                    <Tooltip
                                      title={
                                        <div>
                                          <span>
                                            {"Phone Number: " +
                                              (data?.previousManagerPhoneNumber
                                                ? data?.previousManagerPhoneNumber
                                                : "No Data")}
                                          </span>
                                          <br></br>
                                          <span>
                                            {"Mobile Number: " +
                                              (data?.previousManagerMobileNumber
                                                ? data?.previousManagerMobileNumber
                                                : "No Data")}
                                          </span>
                                        </div>
                                      }
                                      placement="top"
                                    >
                                      {data?.previousManagerId ? (
                                        <div>
                                          <span
                                            className="cursor-pointer"
                                            onClick={() => {
                                              onClickEmployee(
                                                data?.previousManagerId,
                                                data
                                              );
                                              // handleLink(
                                              //   "employee",
                                              //   data?.previousManagerId,
                                              //   data?.officeHierarchyId
                                              // );
                                            }}
                                          >
                                            <div className="blueAndBold underline text-xs">
                                              {data?.previousManager}
                                            </div>
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="col-span-2 expandedData fontExpand">
                                          {data?.previousManager}
                                        </div>
                                      )}
                                    </Tooltip>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </Disclosure.Panel>
                      </div>
                    </>
                  )}
                </Disclosure>
              ) : (
                ""
              )}
              {userPermissions.includes(viewAdditionalPermission) && (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <div className="m-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            Activity History
                          </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className="text-xs  ">
                          <OfficeHierarchyActivyTable data={data} />
                        </Disclosure.Panel>
                      </div>
                    </>
                  )}
                </Disclosure>
              )}
              {userPermissions.includes(viewTrainingPermission) && (
                <Disclosure defaultOpen>
                  {({ open }) => (
                    <>
                      <div className="m-2 bg-white rounded-lg box-shadow">
                        <Disclosure.Button className="disclosureBtn ml-2">
                          <ChevronRight
                            className={`${
                              open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5 `}
                          />
                          <span className="disclosureLabel ml-2">
                            {data?.type === "District"
                              ? "Offices"
                              : "Office Hierarchies"}
                          </span>
                        </Disclosure.Button>
                        <>
                          {data?.type === "Territory" ? (
                            <Disclosure.Panel className="text-xs ">
                              <AreaTable
                                areaRowData={data}
                                onClickOfficeHierarchyName={
                                  onClickOfficeHierarchyName
                                }
                              />
                            </Disclosure.Panel>
                          ) : data?.type === "Area" ? (
                            <Disclosure.Panel className="text-xs">
                              <RegionTable
                                regionRowData={data}
                                onClickOfficeHierarchyName={
                                  onClickOfficeHierarchyName
                                }
                              />
                            </Disclosure.Panel>
                          ) : data?.type === "Region (Market)" ? (
                            <Disclosure.Panel className="text-xs ">
                              <DistrictTable
                                districtRowData={data}
                                onClickOfficeHierarchyName={
                                  onClickOfficeHierarchyName
                                }
                              />
                            </Disclosure.Panel>
                          ) : (
                            <Disclosure.Panel className="text-xs  ">
                              <OfficeHierarchyOfficesTable data={data} />
                            </Disclosure.Panel>
                          )}
                        </>
                      </div>
                    </>
                  )}
                </Disclosure>
              )}
            </div>
          </div>
        </>
      ) : (
        <div>
          <CustomLoader />
        </div>
      )}
    </div>
  );
};

export default OfficeHierarchyView;
